document.addEventListener("DOMContentLoaded", (event) => {
    console.log('work');
    const swiper = new Swiper('.hero-banner__slider.swiper', {
        loop: true,
        spaceBetween: 40,
        speed: 2000,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.hero-banner__pagination',
            type: 'bullets',
            clickable: 'true'
        },
        autoplay: {
            delay: 4000,
        },
    });

});